import { Component, OnInit } from '@angular/core'
import { CountryService } from '../../shared/services/country.service'
import { Country } from '../../shared/interfaces/resources/country.interface'
import { FormControl, FormGroup } from '@angular/forms'

@Component({
  selector: 'app-country-comparison-widget',
  templateUrl: './country-comparison-widget.component.html',
  styleUrls: ['./country-comparison-widget.component.scss']
})
export class CountryComparisonWidgetComponent implements OnInit {
  countries: Country[]

  countryForm: FormGroup

  constructor(private countryService: CountryService) {}

  ngOnInit() {
    this.countryService.list().then((countryRes: Country[]) => {
      this.countries = countryRes

      this.countryForm = new FormGroup({
        country1: new FormControl(
          this.countries[
            Math.floor(Math.random() * this.countries.length)
          ].label
        ),
        country2: new FormControl(
          this.countries[
            Math.floor(Math.random() * this.countries.length)
          ].label
        )
      })
    })
  }
}
